import { Root } from './Root';

export * from './types';

export const OneClickDeployment = Root;
